import postMessageService from '@/modules/common/services/postMessageService'

const LoggerPlugin = {
  install(Vue, options) {
    Vue.prototype.$logMessage = (label, message) => {
      postMessageService.post('send_log_message', {label, message})
    };

    Vue.prototype.$logError = (label, data) => {
      postMessageService.post('send_log_error', {label, data})
    };
  }
};

export default LoggerPlugin;
